var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "md-headline" }, [_vm._v("Targets")]),
      _c(
        "md-layout",
        { attrs: { "md-gutter": 24 } },
        [
          _c(
            "md-layout",
            { attrs: { "md-flex": "100" } },
            [
              _c("license-selector", {
                attrs: {
                  id: "license-selector",
                  multiple: true,
                  showRequiredError:
                    _vm.formSubmitted && _vm.entity.licenses.length == 0
                },
                on: {
                  created: function($event) {
                    return _vm.$emit("created", $event)
                  },
                  error: function($event) {
                    return _vm.$emit("error", $event)
                  }
                },
                model: {
                  value: _vm.entity.licenses,
                  callback: function($$v) {
                    _vm.$set(_vm.entity, "licenses", $$v)
                  },
                  expression: "entity.licenses"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44ae3c92", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44ae3c92","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/forms/ContentTargetsForm.vue
// module id = 937
// module chunks = 0